import axios from "axios";

/**
 * 共通 axios インスタンス
 * main.js（interceptor）と store/index.js の両方で使用する。
 */
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

export default api;
